const routes = [
    {
        path: '/company/risk_management/dashboard',
        name: 'CompanyRiskManagementDashboard',
        component: () => import('../../views/company/risk_management/dashboard/Dashboard.vue')
    },
    {
        path: '/company/risk_management/livejobs/',
        name: 'CompanyRiskManagementDashboardLiveJobs',
        component: () => import('../../views/company/risk_management/dashboard/LiveJobs.vue')
    },
    {
        path: '/company/risk_management/suppliers/',
        name: 'CompanyRiskManagementDashboardSuppliers',
        component: () => import('../../views/company/risk_management/dashboard/Suppliers.vue')
    },
    {
        path: '/company/risk_management/ourjobs/',
        name: 'CompanyRiskManagementDashboardOurJobs',
        component: () => import('../../views/company/risk_management/dashboard/OurJobs.vue')
    },
    {
        path: '/company/risk_management/list',
        name: 'CompanyRiskManagementManageList',
        component: () => import('../../views/company/risk_management/List.vue')
    },
    {
        path: '/company/risk_management/details/:id',
        name: 'CompanyRiskManagementManage_job_details',
        component: () => import('../../views/company/risk_management/Details.vue')
    },
    {
        path: '/company/risk_management/create/job',
        name: 'CompanyRiskManagementManage_create_job',
        component: () => import('../../views/company/risk_management/Create.vue')
    },
    {
        path: '/company/edit/risk_management/:id',
        name: 'CompanyRiskManagementManage_edit_job',
        component: () => import('../../views/company/risk_management/Edit.vue')
    },
    {
        path: '/company/risk_management/create/category/:id',
        name: 'CompanyRiskManagementManage_category_create',
        component: () => import('../../views/company/risk_management/category/Create.vue')
    },
    {
        path: '/company/risk_management/category/details/:risk_id/:category_id',
        name: 'CompanyRiskManagementManage_category_details',
        component: () => import('../../views/company/risk_management/category/Details.vue')
    },
    {
        path: '/company/risk_management/edit/category/:risk_id/:category_id',
        name: 'CompanyRiskManagementManage_category_edit',
        component: () => import('../../views/company/risk_management/category/Edit.vue')
    },
    {
        path: '/company/risk_management/duplicate/category/:risk_id/:category_id',
        name: 'CompanyRiskManagementManageDuplicateCategory',
        component: () => import('../../views/company/risk_management/CloneCategory.vue')
    },
    // {
    //     path: '/company/risk_management/create/section/:risk_id/:category_id',
    //     name: 'CompanyRiskManagement_create_section',
    //     component: () => import('../../views/company/risk_management/category/section/Create.vue')
    // },
    // {
    //     path: '/company/risk_management/section/questions/:category_id/:section_id',
    //     name: 'CompanyRiskManagement_section_questions',
    //     component: () => import('../../views/company/risk_management/category/section/Questions.vue')
    // },
    // {
    //     path: '/company/risk_management/edit/section/:risk_id/:category_id/:section_id',
    //     name: 'CompanyRiskManagement_edit_section',
    //     component: () => import('../../views/company/risk_management/category/section/Edit.vue')
    // },
    // {
    //     path: '/company/risk_management/create/question/:category_id/:section_id',
    //     name: 'CompanyRiskManagement_create_question',
    //     component: () => import('../../views/company/risk_management/category/section/CreateQuestion.vue')
    // },
    // {
    //     path: '/company/risk_management/edit/question/:category_id/:section_id/:id',
    //     name: 'CompanyRiskManagement_edit_question',
    //     component: () => import('../../views/company/risk_management/category/section/EditQuestion.vue')
    // },
    {
        path: '/company/risk_management/question/upload/progress/:prequal_id/:task_id',
        name: 'CompanyRiskManagementQuestionUploadProgress',
        component: () => import('../../views/company/risk_management/QuestionUploadProgress.vue')
    },
    {
        path: '/company/risk_management/invited/suppliers/:risk_id/:category_id',
        name: 'CompanyRiskManagementManage_invited_suppliers',
        component: () => import('../../views/company/risk_management/category/InvitedSuppliers.vue')
    },
    {
        path: '/company/risk_management/invite/system/suppliers/:risk_id/:category_id',
        name: 'CompanyRiskManagementManageInviteSystemSuppliers',
        component: () => import('../../views/company/risk_management/category/SystemSuppliers.vue')
    },
    {
        path: '/company/risk_management/qa/instructions/:category_id',
        name: 'CompanyRiskManagementManage_qa_instructions',
        component: () => import('../../views/company/risk_management/category/qa/AddInstructions.vue')
    },
    {
        path: '/company/risk_management/conduct/qa/:category_id/:participant_id',
        name: 'CompanyRiskManagementManage_conduct_qa',
        component: () => import('../../views/company/risk_management/category/qa/ConductQa.vue')
    },
    {
        path: '/company/risk_management/dd/details/:category_id',
        name: 'CompanyRiskManagementManage_dd_details',
        component: () => import('../../views/company/risk_management/category/dd/Participants.vue')
    },
    {
        path: '/company/risk_management/reports/list',
        name: 'CompanyRiskManagementReportsJobs',
        component: () => import('../../views/company/risk_management/reports/List.vue')
    },
    {
        path: '/company/risk_management/reports/:id',
        name: 'CompanyRiskManagementReports',
        component: () => import('../../views/company/risk_management/reports/Details.vue')
    },
    {
        path: '/company/risk_management/report/progress/:risk_id/:task_id',
        name: 'CompanyRiskManagementReportsProgress',
        component: () => import('../../views/company/risk_management/reports/Progress.vue')
    },
    {
        path: '/company/risk_management/project_management/approved_gantt_chart',
        name: 'CompanyRiskManagementProjectManagementGanttChartApproved',
        component: () => import('../../views/company/risk_management/project_management/timeline/ApprovedGanttChart.vue')
    },
    {
        path: '/company/risk_management/project_management/project_gantt_chart',
        name: 'CompanyRiskManagementProjectManagementGanttChartProject',
        component: () => import('../../views/company/risk_management/project_management/timeline/ProjectGanttChart.vue')
    },
    {
        path: '/company/risk_management/project_management/meetings',
        name: 'CompanyRiskManagementProjectManagementMeetings',
        component: () => import('../../views/company/risk_management/project_management/meetings/Meetings.vue')
    },

]
export default routes;
